import { type IUserService } from './IUserService';
import { UserApi } from 'infrastructure/apis/user/UserApi';
import { User } from 'domains/user';
import { UserMapper } from 'infrastructure/mappers/user/UserMapper';
import { LoginRequestDTO } from 'infrastructure/dtos/login';

export class UserService implements IUserService {
  constructor(readonly api: UserApi) {}

  async login({ password, username }: LoginRequestDTO): Promise<void> {
    await this.api.login({ password, username });
  }

  async authenticate(): Promise<User> {
    const userDTO = await this.api.authenticate();
    return UserMapper.fromDTO(userDTO);
  }

  async updateFCMToken(fcmToken: string): Promise<void> {
    await this.api.updateFCMToken({ fcm_token: fcmToken });
  }

  async logout(): Promise<void> {
    await this.api.logout();
  }

  async deleteAccount(): Promise<void> {
    await this.api.deleteAccount();
  }
}
